module.exports = __webpack_public_path__ + "static/media/realtor-1.3f4339e4.jpeg";